import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "../Header";
import Field from "../../../../../Settings/Content/Components/Field";

import { RequestUpdateAgentPolicy } from "../../../../../../store/actions/integrationsActions";

const MIN_MAX_VALUES = {
  minSuspectSize: [12000, 36000],
  maxSuspectSize: [580000, 1740000],
  samplePollIterations: [80, 500],
  samplePollIntervalMs: [9000, 60000],
};

const ScanForm = ({ selectedHost }) => {
  const dispatch = useDispatch();

  const policy = useSelector((state) => state.integrations.agentPolicy);
  const updatePolicyLoading = useSelector((state) => state.integrations.updatePolicyLoading);

  const [scanUI, setScanUI] = useState({
    ...policy?.settings?.scan,
  });

  const inputChangeHandler = (e) => {
    const { name, value } = e.target;
    setScanUI((prev) => ({
      ...prev,
      [name]: value === "" ? "" : Number(value),
    }));
  };

  const blurHandler = (e) => {
    const { name, value } = e.target;
    const limits = MIN_MAX_VALUES[name];
    if (!limits) return;

    const [min, max] = limits;
    let newValue = Number(value);

    if (newValue < min) newValue = min;
    if (newValue > max) newValue = max;

    setScanUI((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const checkSaveButtonDisabled = () => {
    const backend = policy?.settings?.scan;
    const ui = scanUI;

    if (!backend || !ui) return true;

    if (
      backend.minSuspectSize !== ui.minSuspectSize ||
      backend.maxSuspectSize !== ui.maxSuspectSize ||
      backend.samplePollIterations !== ui.samplePollIterations ||
      backend.samplePollIntervalMs !== ui.samplePollIntervalMs
    ) {
      return false;
    }

    return true;
  };

  const updateAgentSettingsHandler = (e) => {
    e.preventDefault();
    if (updatePolicyLoading) return;

    dispatch(
      RequestUpdateAgentPolicy({
        id: policy.id,
        settings: {
          ...policy.settings,
          scan: scanUI,
        },
        host: selectedHost,
      }),
    );
  };

  return (
    <>
      <Header
        policy={policy}
        selectedHost={selectedHost}
        toggleProps={{
          show: false,
        }}
      />

      <form className="agent-policy-form">
        <div className="agent-policy-form__line">
          <Field
            label="Min Suspect Size in bytes"
            tooltipText="Min: 12000, Max: 36000"
            width="220px"
            name="minSuspectSize"
            value={scanUI.minSuspectSize}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
          <Field
            label="Max Suspect Size in bytes"
            tooltipText="Min: 580000, Max: 1740000"
            width="220px"
            name="maxSuspectSize"
            value={scanUI.maxSuspectSize}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
        </div>

        <div className="agent-policy-form__line">
          <Field
            label="Sample Poll Iterations"
            tooltipText="Min: 80, Max: 500"
            width="220px"
            name="samplePollIterations"
            value={scanUI.samplePollIterations}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
          <Field
            label="Sample Poll Interval in ms"
            tooltipText="Min: 9000, Max: 60000"
            width="220px"
            name="samplePollIntervalMs"
            value={scanUI.samplePollIntervalMs}
            onChange={inputChangeHandler}
            onBlur={blurHandler}
            type="number"
          />
        </div>

        <button
          className="primary-button"
          disabled={checkSaveButtonDisabled()}
          onClick={updateAgentSettingsHandler}>
          Save
        </button>
      </form>
    </>
  );
};

export default ScanForm;
